import React from 'react';
import styles from './UnAuthUser.module.scss';
import UnauthorizedImg from '../../assets/images/unauth-access.jpg';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';
const Unauthuser = () => {
	const { logoutUser } = useAuthorizationContext();
	return (
		<div className={styles.unauthcontainer}>
			<div className={styles.contentcontainer}>
				<div className={styles.imgcontainer}>
					<img src={UnauthorizedImg} alt="" className={styles.imgstyle} />
				</div>
				<div className={styles.errorcontainer}>
					<div className={styles.sorrycontainer}>
						<p className="sry-txt">Sorry !</p>
					</div>
					<div className={styles.errortxtcontainer}>
						<span className={styles.errortxt}>
							You are not authorized to access this page please check your login
							credentials or contact the administrator for access.
						</span>
					</div>
					<div onClick={logoutUser} className={styles.linkcontainer}>
						<span className={styles.linktxt}>click to</span>
						<div onClick={logoutUser} className={styles.logoutbtn}>
							Logout
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Unauthuser;
